import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Mapper } from './Mapper';
import { useCallback, useEffect } from 'react';
import { NoResults2 } from 'Components';
import { AddCommaToNumber } from 'Utils/AddCommaToNumber';
import { useSupplierContext } from 'Hooks/useSupplierContext';
import { useSuppliersDispatchType } from 'Hooks/useSuppliersDispatchType';

export const Results = () => {
  const { dispatchSuppliers, filters, suppliers } = useSupplierContext();
  const dispatchType = useSuppliersDispatchType();

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage
    .textResult;

  const initFilteredSuppliers = useCallback(() => {
    dispatchSuppliers({
      type: dispatchType,
      payload: { value: filters },
    });
  }, [dispatchSuppliers, dispatchType, filters]);

  useEffect(() => {
    initFilteredSuppliers();
  }, [initFilteredSuppliers]);

  return (
    <Stack>
      {suppliers.filteredResults.length > 0 ? (
        <Typography
          variant='body2'
          aria-live='polite'
          aria-atomic='true'
          component='h2'
        >
          {`${dictionary.found} ${AddCommaToNumber(
            suppliers.filteredResults.length
          )} ${dictionary.results}`}
        </Typography>
      ) : (
        <NoResults2
          textSearch={dictionary.noResult}
          textSx={{ width: isDesktop ? undefined : '175px' }}
        />
      )}
      <Mapper />
    </Stack>
  );
};
